/**
 * Presentation helpers for owner Activity trace views (no server object projection).
 */

import type { CognitoryActivityAttentionClass } from "../api/cognitoryQuestionAnswerTraceOwnerReadRebuild";

export const COGNITORY_ACTIVITY_LIST_FORBIDDEN_COPY =
  "Activity is available to Cognitory owners only." as const;

export const COGNITORY_ACTIVITY_DETAIL_FORBIDDEN_COPY =
  "This activity item is unavailable or you do not have access." as const;

export const COGNITORY_ACTIVITY_SESSION_EXPIRED_COPY =
  "Sign-in session expired. Sign in again." as const;

export const COGNITORY_ACTIVITY_INVALID_REQUEST_COPY =
  "This activity request could not be processed." as const;

export function formatActivityDurationMs(durationMs: number): string {
  if (!Number.isFinite(durationMs) || durationMs < 0) {
    return "0 ms";
  }
  const boundedMs = Math.min(Math.trunc(durationMs), 86_400_000);
  if (boundedMs < 1000) {
    return `${boundedMs} ms`;
  }
  const seconds = Math.min(Math.round(boundedMs / 1000), 86_400);
  return `${seconds} s`;
}

export function formatActivityAttentionLabel(
  attentionClass: CognitoryActivityAttentionClass,
): string {
  switch (attentionClass) {
    case "answered":
      return "Answered";
    case "governed_refusal":
      return "Governed refusal";
    case "verification_rejection":
      return "Verification rejection";
    case "operational_failure":
      return "Operational failure";
    default:
      return "Activity";
  }
}

export function formatActivitySupportReference(
  supportReference: string | null,
): string | null {
  if (!supportReference) {
    return null;
  }
  return `Support reference: ${supportReference}`;
}

export function formatActivityCitationSummary(input: {
  renderedCitationCount: number;
  citationLabels: readonly string[];
}): string {
  const count = input.renderedCitationCount;
  if (count <= 0) {
    return "No citations";
  }
  const labels = input.citationLabels.slice(0, count).join(", ");
  return `${count} citation${count === 1 ? "" : "s"}${labels ? ` (${labels})` : ""}`;
}
